interface StatusBadgeProps {
  label: string;
  color: string;
  style?: React.CSSProperties;
}

export function StatusBadge({ label, color, style }: StatusBadgeProps) {
  return (
    <span style={{
      display: "inline-block",
      background: color,
      color: "#fff",
      padding: "0.15rem 0.55rem",
      borderRadius: 999,
      fontSize: "0.75rem",
      fontWeight: 600,
      letterSpacing: "0.02em",
      whiteSpace: "nowrap",
      ...style,
    }}>
      {label}
    </span>
  );
}
